export default "__VITE_ASSET__CykFV0IZ__"